<template>
    <div style="height: 100%;" :class="'test'+index"><slot></slot></div>
</template>

<script>
  import PerfectScrollbar from "perfect-scrollbar";
  import "perfect-scrollbar/css/perfect-scrollbar.css";

  function hasElement(className) {
    return document.getElementsByClassName(className).length > 0;
  }
  function initScrollbar(className) {
    if (hasElement(className)) {
      new PerfectScrollbar(`.${className}`);
    } else {
      // try to init it later in case this component is loaded async
      setTimeout(() => {
        initScrollbar(className);
      }, 100);
    }
  }
  export default {
    name: "WidgetOptions",
    data(){return{
      index: Math.round(Math.random()*1000),
    }},
    mounted(){
      initScrollbar('test'+this.index)
    }
  }
</script>
